import React from "react";

const SvgComments = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_24440_1906)">
        <path
          d="M3.9375 2.25C2.59802 2.25 1.5 3.34802 1.5 4.6875V10.6875V12.9507C1.5 13.6825 2.39622 14.1394 2.98828 13.7095C2.98853 13.7095 2.98877 13.7095 2.98901 13.7095L4.60913 12.531C4.91811 13.5231 5.84788 14.25 6.9375 14.25H11.6294L15.011 16.7095C15.0112 16.7095 15.0115 16.7095 15.0117 16.7095C15.6038 17.1394 16.5 16.6825 16.5 15.9507V13.6875V7.6875C16.5 6.34802 15.402 5.25 14.0625 5.25H13.5V4.6875C13.5 3.34802 12.402 2.25 11.0625 2.25H3.9375ZM3.9375 3.375H11.0625C11.7938 3.375 12.375 3.95623 12.375 4.6875V8.8125C12.375 9.54377 11.7938 10.125 11.0625 10.125H6.1875C6.06854 10.125 5.95264 10.1627 5.85645 10.2327L2.625 12.583V10.6875V4.6875C2.625 3.95623 3.20623 3.375 3.9375 3.375ZM13.5 6.375H14.0625C14.7938 6.375 15.375 6.95623 15.375 7.6875V13.6875V15.583L12.1436 13.2327C12.0474 13.1627 11.9315 13.125 11.8125 13.125H6.9375C6.20623 13.125 5.625 12.5438 5.625 11.8125V11.792L6.37061 11.25H11.0625C12.402 11.25 13.5 10.152 13.5 8.8125V6.375Z"
          className="fill-current"
        />
      </g>
      <defs>
        <clipPath id="clip0_24440_1906">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgComments;
